import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  ChevronDown, 
  ChevronUp, 
  Menu, 
  X, 
  Brain, 
  Eye, 
  Shield, 
  Users, 
  Building2,
  Factory,
  Microscope,
  Car,
  GraduationCap,
  ArrowRight,
  Zap,
  BarChart3,
  Camera,
  Lightbulb,
  Play,
  ShoppingBag,
  Building,
  Check
} from 'lucide-react';

const HeaderComp = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
      const handleScroll = () => {
        setIsScrolled(window.scrollY > 20);
      };
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // After React Router client-side navigation, the browser doesn't auto-scroll
    // to hash targets. This effect handles it so /#section links work from any route.
    useEffect(() => {
      if (location.hash) {
        const el = document.querySelector(location.hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }
    }, [location.pathname, location.hash]);

    const navItems = [
      { name: 'Industries', to: '/#industries' },
      { name: 'Expertise', to: '/#expertise' },
      { name: 'Projects', to: '/#projects' },
      { name: 'Contact', to: '/#contact' }
    ];

    // On the home page scroll to the contact section; from any other route
    // navigate home with the #contact hash (the section only exists there).
    const goToContact = () => {
      const el = document.getElementById('contact');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      } else {
        window.location.href = '/#contact';
      }
    };
  
    return (
        <header 
          className={`fixed w-full z-50 transition-all duration-300 ${
            isScrolled ? 'bg-white/90 backdrop-blur-md shadow-md' : 'bg-transparent'
          }`}
        >
          <div className="container mx-auto px-4 py-2">
            <div className="flex justify-between items-center">
              <div className="flex items-center">
                {/* Large logo container */}
               
              </div>
              
              <nav className="hidden lg:flex items-center space-x-8">
                {navItems.map((item) => (
                  <Link
                    key={item.name}
                    to={item.to}
                    className={`relative group py-2 ${
                      isScrolled ? 'text-gray-800' : 'text-white'
                    }`}
                  >
                    <span className="relative z-10">{item.name}</span>
                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 group-hover:w-full transition-all duration-300"></span>
                  </Link>
                ))}
                <Link
                  to="/ai-learning-path"
                  className={`relative group py-2 ${
                    isScrolled ? 'text-gray-800' : 'text-white'
                  }`}
                >
                  <span className="relative z-10">AI Learning Path</span>
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 group-hover:w-full transition-all duration-300"></span>
                </Link>
                <button
                  onClick={goToContact}
                  className="bg-blue-600 text-white px-6 py-2 rounded-full hover:bg-blue-700 transition-colors duration-300">
                  Get Started
                </button>
              </nav>
              
              <button 
                className="lg:hidden z-50"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                {isMenuOpen ? <X className="text-gray-800" /> : <Menu className={isScrolled ? 'text-gray-800' : 'text-white'} />}
              </button>
            </div>
          </div>
          
          {/* Mobile Menu */}
          <div className={`fixed inset-0 bg-white/95 backdrop-blur-md transition-transform duration-300 lg:hidden ${
            isMenuOpen ? 'translate-x-0' : 'translate-x-full'
          }`}>
            <div className="container mx-auto px-4 py-20">
              <nav className="flex flex-col space-y-6">
                {navItems.map((item) => (
                  <Link
                    key={item.name}
                    to={item.to}
                    className="text-2xl font-semibold text-gray-800 hover:text-blue-600 transition-colors duration-300"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.name}
                  </Link>
                ))}
                <Link
                  to="/ai-learning-path"
                  className="text-2xl font-semibold text-gray-800 hover:text-blue-600 transition-colors duration-300"
                  onClick={() => setIsMenuOpen(false)}
                >
                  AI Learning Path
                </Link>
                <button
                  onClick={goToContact}
                  className="bg-blue-600 text-white px-8 py-3 rounded-full hover:bg-blue-700 transition-colors duration-300 text-lg">
                  Get Started
                </button>
              </nav>
            </div>
          </div>
        </header>
    );
}

export default HeaderComp;
